import { useIntlOptions } from '@plandok/i18n'
import SelectInput from './index'
import React from 'react'

export default function SelectWithTranslate({ options, ...props }: any) {
   const { convertOptions } = useIntlOptions()

   return <SelectInput {...props} options={convertOptions(options)} />
}
